import React, { useContext, useEffect, useState, useRef } from "react";
import { Typography, Grid, Paper} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { getTicksData, saveFutPrice, saveSpotPrice, saveSyntPrice, saveSynToken, getOptionChainInstrumentsData } from "../../redux/actions/optionChain";
import { isEmptyObject, fmt, deleteCookieCredentials, sessionExpireHandle } from "../../util/helper";
import moment from "moment";
import AppContext from "../../context/Context";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import Down from "@material-ui/icons/ArrowDownward";
import Up from "@material-ui/icons/ArrowUpward";
import UnChanged from "@material-ui/icons/ArrowForward";
import { Modal } from "antd";
// style constant
const useStyles = makeStyles((theme) => ({
  textClass: {
    margin: "1px 4px",  
    padding: "1px 4px",
    fontSize: "12px",
    //color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
    fontWeight: "400",
    fontFamily: "poppins",
    textAlign: "center"
  },
  icon: {
    fontSize: "16px !important",
    fontWeight: "bold",
  },
  up : {
    color : ({ isDark }) => (isDark ? '#16A34A' : '#04ad6f'),
  },
  down : {
    color: ({ isDark }) => (isDark ? '#F87171' : '#E74C3C'),
  },
  unChg : {
    color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
  },
  summaryPaper : {
    margin: "0rem 0.3rem",
    padding: "5px 4px",
    backgroundColor : ({ isDark }) => (isDark ? "#0b1727" : "#fff"),
    width: "232px",
    boxShadow:"inherit",
    border: ({ isDark }) => (isDark ? "1px solid #444" : "1px solid #d9d9d9")
  },
  main:{
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  }
}));

const TokensComp = ({ spotToken, futToken, source,  getRealSpotprice, instrument, expiry }) => {
  const {
    config: { isDark, isNavbarVerticalCollapsed },
    setConfig,
  } = useContext(AppContext);
  const synFut = useSelector((state) => state?.optionChaininstruments?.synFut);
  const synToken = useSelector((state) => state?.optionChaininstruments?.synFutToken, shallowEqual);
  const optionChainContainer = useSelector((state) => state?.optionChaininstruments?.data);
  const optionChainData = optionChainContainer?.optData;

  const dispatch = useDispatch();

  const classes = useStyles({ isDark: isDark });
  const [data, setData] = useState({});
  const [defSynFut, setdefSynFut] = useState(0);

  const [time, setTime] = useState('');
  const tokensDataRef = useRef();
  const prevDataRef = useRef();
  const timeRef = useRef();
  const synRef = useRef();
  const timeRefSysFut = useRef();

  // session expiring handle


  const getRealSpotpriceRef = useRef(getRealSpotprice);

  useEffect(() => {
    getRealSpotpriceRef.current = getRealSpotprice;
  }, [getRealSpotprice]);

  useEffect(() => {
    //subscribe for socket data
    
    synRef.current = {};
     if(synToken && Object.keys(synToken).length > 0 && source && spotToken && futToken) {
      if(synToken.symbolsToStrikePrice) {
          var subscription1 = source
            .subscribe("" + synToken.symbolsToStrikePrice.CE, (message) => handleResponseSyn(message, 'CE', synToken.strike))
            .on("unsubscribe", () => {})
            .on("subscribe", () => {})
            .on("error", (err) => handleSubscribeError(err, spotToken));
            synRef.current["CE"] = {};

          var subscription2 = source
            .subscribe("" + synToken.symbolsToStrikePrice.PE, (message) => handleResponseSyn(message, 'PE', synToken.strike))
            .on("unsubscribe", () => {})
            .on("subscribe", () => {})
            .on("error", (err) => handleSubscribeError(err, futToken));
            synRef.current['PE'] = {};

         
      }
     
   
        var subscription3 = source
          .subscribe("" + spotToken, (message) => handleResponse(message, 'spot'))
          .on("unsubscribe", () => {})
          .on("subscribe", () => {})
          .on("error", (err) => handleSubscribeError(err, spotToken));
        var subscription4 = source
          .subscribe("" + futToken, (message) => handleResponse(message, 'fut'))
          .on("unsubscribe", () => {})
          .on("subscribe", () => {})
          .on("error", (err) => handleSubscribeError(err, futToken));

        return () => {
          subscription1.unsubscribe();
          subscription2.unsubscribe();
          subscription3.unsubscribe();
          subscription4.unsubscribe();
        };
      }
    
  }, [source, spotToken, futToken, synToken]);

  const tagsToReplace = { "&": "&amp;", "<": "&lt;", ">": "&gt;" };

  function handleSubscribeError(err, token) {
    console.log("Error subscribing on channel symbol ", token, err);
  }

  function replaceTag(tag) {
    return tagsToReplace[tag] || tag;
  }

  function safeTagsReplace(str) {
    return str.replace(/[&<>]/g, replaceTag);
  }

  const handleResponseSyn = (message, type, strike) => {
    if (!message?.data || message.data.lp === undefined) return;
    synRef.current[type] = message.data;
    
    const ce = synRef.current['CE'];
    const pe = synRef.current['PE'];

    if(ce && pe && ce.lp !== undefined && pe.lp !== undefined && strike) {
      const synPrice = (parseFloat(strike) + parseFloat(ce.lp)) - parseFloat(pe.lp);
      
      if (!isNaN(synPrice)) {
        setdefSynFut(synPrice);
        const tickTime = message.data.exts;
        if (!timeRefSysFut.current || !moment(timeRefSysFut.current).isSame(tickTime, 'minute')) {
          timeRefSysFut.current = tickTime;
          dispatch(saveSyntPrice(synPrice));
        }
      }
    } 
  }

  const handleResponse = (message, type) => {
    if (tokensDataRef.current && !isEmptyObject(tokensDataRef.current)) {
      const myJSON = JSON.stringify(message);
      const text = safeTagsReplace(myJSON);
      const data = JSON.parse(text)?.data;

      let dLP = data.lp;
      let dPrev = prevDataRef.current[type+'Prev'];
      let dChg = dLP - dPrev;
      let dChgP =
        dPrev !== 0 ? (100 * (dLP - dPrev)) / dPrev : undefined;
        
      let newData = {...tokensDataRef.current, [type + 'LP'] : dLP, [type+'Prev'] : dPrev, [type+'Chg'] : dChg, [type+'ChgP'] : dChgP }

      if (!isEmptyObject(newData)) {
        setData(newData);
      }
      if (!moment(timeRef.current).isSame(data.exts, 'minute')) {
          setTime(data.exts);
          timeRef.current = data.exts;
          if (getRealSpotpriceRef.current) {
            getRealSpotpriceRef.current(newData.spotLP);
          }
          if(type === 'spot') {
            dispatch(saveSpotPrice(newData.spotLP));
          }
          if(type === 'fut') {
            dispatch(saveFutPrice(newData.futLP));
          }
      }
      tokensDataRef.current[type + 'LP'] = dLP;
      tokensDataRef.current[type + 'Prev'] = dPrev;
      tokensDataRef.current[type + 'Chg'] = dChg;
      tokensDataRef.current[type + 'ChgP'] = dChgP;
    }
  };
  const prevTokensKeyRef = useRef("");

  useEffect(() => {
      if ((!optionChainData || optionChainData.length === 0) && instrument && expiry) {
         dispatch(getOptionChainInstrumentsData(instrument, expiry));
      }
  }, [optionChainData, instrument, expiry, dispatch]);

  useEffect(() => {
    const isSynTokenValid = synToken && !isEmptyObject(synToken) && optionChainData && optionChainData.some(d => d.instrumentToken === synToken.symbolsToStrikePrice?.CE);

    if (!isSynTokenValid && optionChainData && optionChainData.length > 0 && data.spotLP) {
      let lastIteratePrice = 0;
      let middleStrikeFn = 0;
      const price = data.spotLP;
      
      for (let i = 0; i < optionChainData.length; i++) {
          if (price < optionChainData[i]?.strikePrice) {
              const middle = lastIteratePrice + (optionChainData[i].strikePrice - lastIteratePrice) / 2;
              if (middle > price) {
                  middleStrikeFn = lastIteratePrice;
              } else {
                  middleStrikeFn = optionChainData[i].strikePrice;
              }
              break;
          }
          lastIteratePrice = optionChainData[i]?.strikePrice;
      }
      
      if (middleStrikeFn) {
          const ce = optionChainData.find(d => d.strikePrice === middleStrikeFn && d.instrumentType === 'CE');
          const pe = optionChainData.find(d => d.strikePrice === middleStrikeFn && d.instrumentType === 'PE');
          
          if (ce && pe) {
              const newSynToken = {
                  strike: middleStrikeFn,
                  symbolsToStrikePrice: {
                      CE: ce.instrumentToken,
                      PE: pe.instrumentToken
                  }
              };
              dispatch(saveSynToken(newSynToken));
          }
      }
 }
  }, [synToken, optionChainData, data.spotLP, dispatch]);

  useEffect(() => {
    async function fetchPrice() {
      if(!futToken && !spotToken) {
        return false;
      }
      const tokens = [futToken, spotToken, synToken?.symbolsToStrikePrice?.CE, synToken?.symbolsToStrikePrice?.PE].filter(Boolean);
      const uniqSorted = Array.from(new Set(tokens)).sort();
      const newKey = uniqSorted.join(',');
      if (!newKey) return;
      if (prevTokensKeyRef.current === newKey) {
        return;
      }
      prevTokensKeyRef.current = newKey;
      const data = await getTicksData(uniqSorted);
      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      } else {
       
        let futLP = data[futToken]?.lp;
        dispatch(saveFutPrice(futLP));
        let futPrev = data[futToken]?.prev?.p;
        let spotLP = data[spotToken].lp;
        dispatch(saveSpotPrice(spotLP));
        let spotPrev = data[spotToken]?.prev?.p;
        let spotChg = spotLP - spotPrev;
        let spotChgP =
          spotPrev !== 0 ? (100 * (spotLP - spotPrev)) / spotPrev : undefined;
        let futChg = futLP - futPrev;
        let futChgP =
          futPrev !== 0 ? (100 * (futLP - futPrev)) / futPrev : undefined;
        const newD = {
          futLP,
          futPrev,
          futChg,
          futChgP,
          spotLP,
          spotPrev,
          spotChg,
          spotChgP,
        }
        setData(newD);
        setTime(data[spotToken].exts);

        if(synToken.symbolsToStrikePrice && synToken.symbolsToStrikePrice.CE && synToken.symbolsToStrikePrice.PE) {
            const ceLP = data[synToken.symbolsToStrikePrice.CE]?.lp;
            const peLP = data[synToken.symbolsToStrikePrice.PE]?.lp;
            
            if (ceLP !== undefined && peLP !== undefined) {
              const synPrice = (parseFloat(synToken.strike) + parseFloat(ceLP)) - parseFloat(peLP);
              if (!isNaN(synPrice)) {
                dispatch(saveSyntPrice(synPrice));
                setdefSynFut(synPrice);
              }
            }
        }
        timeRef.current = data[spotToken].exts;
        prevDataRef.current = {spotPrev, futPrev}
        tokensDataRef.current = newD;
      }
    }

      if (spotToken && futToken) {
        fetchPrice();
      }
  }, [spotToken, futToken, synToken?.symbolsToStrikePrice?.CE, synToken?.symbolsToStrikePrice?.PE]);
  
  return (
    <div  className={classes.main+" tokenCom"}>
        <Paper elevation={2} className={classes.summaryPaper} style={{width: "158px",border:isDark ? "1px solid #444" : "1px solid #d9d9d9", backgroundColor:isDark ? "#0b1727" : "#fff"}}>
          <Grid item style={{ marginRight: "5px" }} >
            <Typography className={classes.textClass+" text-div"} >
            <span className="me-2">Syn Fut</span>

            <span>{fmt(defSynFut ? defSynFut.toFixed(2) : defSynFut === 0 ? 0 : '-')} &nbsp; &nbsp;</span> 
            </Typography>
          </Grid>
        </Paper>
        <Paper elevation={2} className={classes.summaryPaper} style={{border:isDark ? "1px solid #444" : "1px solid #d9d9d9", backgroundColor:isDark ? "#0b1727" : "#fff"}}>
          <Grid item style={{ marginRight: "5px" }} >
            <Typography className={classes.textClass+" text-div"}  >
            <span className="me-2">Spot Price</span>

            <span className={data.spotChg > 0 ? "text-success" : data.spotChg < 0 ? "text-danger": "" }>{fmt(data.spotLP ? data.spotLP.toFixed(2) : data.spotLP === 0 ? 0 : '-')} &nbsp; &nbsp;
              {/* {fmt(data.spotChg ? data.spotChg.toFixed(2) : data.spotChg === 0 ? 0 : '-')} &nbsp; &nbsp; */}
              {data.spotChg > 0 ? <Up className={`${classes.icon} ${classes.up}`} /> : data.spotChg < 0 ? <Down className={`${classes.icon} ${classes.down}`} /> : <UnChanged className={`${classes.icon} ${classes.unChg}`} />} &nbsp;
              {fmt(data.spotChgP ? data.spotChgP.toFixed(2) : data.spotChgP === 0 ? 0 : '-')}%{" "}
              </span> 
            </Typography>
          </Grid>
        </Paper>
        <Paper elevation={2} className={classes.summaryPaper} style={{border:isDark ? "1px solid #444" : "1px solid #d9d9d9",backgroundColor:isDark ? "#0b1727" : "#fff"}}>
        <Grid item  >
          <Typography className={classes.textClass+" text-div"}  >
            <span className="me-2">Future Price</span>
            <span className={data.futChg > 0 ? "text-success" : data.futChg < 0 ? "text-danger": "" }>
                  {fmt(data.futLP ? data.futLP.toFixed(2) : data.futLP === 0 ? 0 : '-')} &nbsp; &nbsp;
                  {/* {fmt(data.futChg ? data.futChg.toFixed(2) : data.futChg === 0 ? 0 : '-')} &nbsp; &nbsp; */}
                  {data.futChg > 0 ? <Up className={`${classes.icon} ${classes.up}`} /> : data.futChg < 0 ? <Down className={`${classes.icon} ${classes.down}`} /> : <UnChanged className={`${classes.icon} ${classes.unChg}`} />} &nbsp;
                  {fmt(data.futChgP ? data.futChgP.toFixed(2) : data.futChgP === 0 ? 0 : '-')}%{" "}
            </span>
          </Typography>
        </Grid>
      </Paper>
 
    
    </div>
  );
};

export default TokensComp;
